var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"not-found-layout"},[_c('j-svg-icon',{staticClass:"not-found-img",attrs:{"name":"404"}}),_c('span',{staticClass:"not-found-desc"},[_vm._v(" "+_vm._s(_vm.name)+" 页面未找到，请检查菜单地址,或联系管理员 ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }